module.exports = __webpack_public_path__ + "static/media/result_fg_ja.d33bf296.jpg";